import styled from 'styled-components';

export const ScFavoriteButton = styled.div<{ isFavorite: boolean }>`
  position: relative;
  padding: 8px;
  background-color: ${({ theme, isFavorite }) =>
    isFavorite ? theme.whiteColor : theme.grayLightColor};
  height: 40px;
  width: 40px;
  border-radius: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
